export function normalizeString(string) {
    let temp_string = string.toString().trim().split(".")[0];
    return temp_string.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '-');
}


